import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';

import commonEn from './locales/en/common.json';
import commonTa from './locales/ta/common.json';
import authEn from './locales/en/auth.json';
import authTa from './locales/ta/auth.json';
import dashboardEn from './locales/en/dashboard.json';
import dashboardTa from './locales/ta/dashboard.json';
import ordersEn from './locales/en/orders.json';
import ordersTa from './locales/ta/orders.json';
import customersEn from './locales/en/customers.json';
import customersTa from './locales/ta/customers.json';
import suppliersEn from './locales/en/suppliers.json';
import suppliersTa from './locales/ta/suppliers.json';
import employeesEn from './locales/en/employees.json';
import employeesTa from './locales/ta/employees.json';
import purchaseOrdersEn from './locales/en/purchaseOrders.json';
import purchaseOrdersTa from './locales/ta/purchaseOrders.json';
import paymentsEn from './locales/en/payments.json';
import paymentsTa from './locales/ta/payments.json';
import creditDebitNotesEn from './locales/en/creditDebitNotes.json';
import creditDebitNotesTa from './locales/ta/creditDebitNotes.json';
import inventoryEn from './locales/en/inventory.json';
import inventoryTa from './locales/ta/inventory.json';
import reportsEn from './locales/en/reports.json';
import reportsTa from './locales/ta/reports.json';
import taxProfileEn from './locales/en/taxProfile.json';
import taxProfileTa from './locales/ta/taxProfile.json';
import barcodeEn from './locales/en/barcode.json';
import barcodeTa from './locales/ta/barcode.json';
import bulkUploadEn from './locales/en/bulkUpload.json';
import bulkUploadTa from './locales/ta/bulkUpload.json';
import profileEn from './locales/en/profile.json';
import profileTa from './locales/ta/profile.json';
import assistantEn from './locales/en/assistant.json';
import assistantTa from './locales/ta/assistant.json';
import widgetsEn from './locales/en/widgets.json';
import widgetsTa from './locales/ta/widgets.json';
import billingEn from './locales/en/billing.json';
import billingTa from './locales/ta/billing.json';
import adminEn from './locales/en/admin.json';
import adminTa from './locales/ta/admin.json';
import categoriesEn from './locales/en/categories.json';
import categoriesTa from './locales/ta/categories.json';
import discountRulesEn from './locales/en/discountRules.json';
import discountRulesTa from './locales/ta/discountRules.json';

export const LANG_COOKIE = 'lang';
// Adding a language: add its code here, add its native name below, and add
// its locale JSON files + imports/resources/ns entries above — nothing else
// (the language dropdown in OrderTrackingApp renders from these two lists).
export const SUPPORTED_LANGUAGES = ['en', 'ta'];
export const LANGUAGE_NAMES = {
  en: 'English',
  ta: 'தமிழ்',
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: commonEn, auth: authEn, dashboard: dashboardEn, orders: ordersEn, customers: customersEn, suppliers: suppliersEn, employees: employeesEn, purchaseOrders: purchaseOrdersEn, payments: paymentsEn, creditDebitNotes: creditDebitNotesEn, inventory: inventoryEn, reports: reportsEn, taxProfile: taxProfileEn, barcode: barcodeEn, bulkUpload: bulkUploadEn, profile: profileEn, assistant: assistantEn, widgets: widgetsEn, billing: billingEn, admin: adminEn, categories: categoriesEn, discountRules: discountRulesEn },
      ta: { common: commonTa, auth: authTa, dashboard: dashboardTa, orders: ordersTa, customers: customersTa, suppliers: suppliersTa, employees: employeesTa, purchaseOrders: purchaseOrdersTa, payments: paymentsTa, creditDebitNotes: creditDebitNotesTa, inventory: inventoryTa, reports: reportsTa, taxProfile: taxProfileTa, barcode: barcodeTa, bulkUpload: bulkUploadTa, profile: profileTa, assistant: assistantTa, widgets: widgetsTa, billing: billingTa, admin: adminTa, categories: categoriesTa, discountRules: discountRulesTa },
    },
    lng: Cookies.get(LANG_COOKIE) || 'en',
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'orders', 'customers', 'suppliers', 'employees', 'purchaseOrders', 'payments', 'creditDebitNotes', 'inventory', 'reports', 'taxProfile', 'barcode', 'bulkUpload', 'profile', 'assistant', 'widgets', 'billing', 'admin', 'categories', 'discountRules'],
    interpolation: { escapeValue: false },
  });

document.documentElement.lang = i18n.language;
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export function changeLanguage(lang) {
  if (!SUPPORTED_LANGUAGES.includes(lang)) return;
  i18n.changeLanguage(lang);
  Cookies.set(LANG_COOKIE, lang, { expires: 365 });
}

export default i18n;
